import { render, staticRenderFns } from "./StatusTableAgGridComponentMerchant.vue?vue&type=template&id=29b567c8&scoped=true&"
import script from "./StatusTableAgGridComponentMerchant.vue?vue&type=script&lang=js&"
export * from "./StatusTableAgGridComponentMerchant.vue?vue&type=script&lang=js&"
import style0 from "./StatusTableAgGridComponentMerchant.vue?vue&type=style&index=0&id=29b567c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b567c8",
  null
  
)

export default component.exports